export default __webpack_public_path__ + "static/media/title.13db1a7c.svg";